import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import LineCopyIcon from 'LuxKit/Icons/line/LineCopyIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import useCopyWithFeedback from 'hooks/useCopyWithFeedback'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import SpacedMarkdownRender from './SpacedMarkdownRender'
import { rem } from 'polished'

const PromoCodeButton = styled(TextButton)`
  justify-content: space-between;
`

const ModalContentWrapper = styled.div`
  padding: ${rem(20)} 0 ${rem(16)};
`

interface Props {
  title: string
  promoCode: string
  /** HTML string for terms and conditions */
  termsAndConditions: string
  primaryActionText?: string
  primaryActionHref?: string
}

function LuxPlusPromoCodeModal({ title, promoCode, termsAndConditions, primaryActionText, primaryActionHref }: Props) {
  const intl = useIntl()
  const hasPrimaryAction = primaryActionText && primaryActionHref
  const { isCopied, handleCopy } = useCopyWithFeedback(promoCode)

  return (
    <Modal
      title={title}
      primaryActionText={hasPrimaryAction ? primaryActionText : undefined}
      primaryActionHref={hasPrimaryAction ? primaryActionHref : undefined}
      primaryActionTarget={hasPrimaryAction ? '_blank' : undefined}
    >
      <ModalContentWrapper>
        <Group direction="vertical" gap={20}>
          <Group direction="vertical" gap={4}>
            <BodyText variant="large" weight="bold">{intl.formatMessage({
              id: 'Gn-lty7Uyx_NPpQTkcpD',
              defaultMessage: 'Promo code',
              description: 'Label for promotional code section in LuxPlus promo code modal',
            })}
            </BodyText>
            <PromoCodeButton
              kind="secondary"
              size="large"
              variant="dark"
              shape="square"
              fit="full-width"
              endIcon={isCopied ? <LineCheckIcon /> : <LineCopyIcon />}
              isSelected={isCopied}
              onClick={handleCopy}
            >
              {promoCode}
            </PromoCodeButton>
          </Group>
          {!!termsAndConditions && <SpacedMarkdownRender content={termsAndConditions} type="compact" fontSize="large" />}
        </Group>

      </ModalContentWrapper>
    </Modal>
  )
}

export default LuxPlusPromoCodeModal
